import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class BanditCampLargeSalvageableTileEntity extends TileEntity {
	public static readonly frameName = FrameName.BANDIT_CAMP_LARGE;
}

export default BanditCampLargeSalvageableTileEntity;
